<deletemodal [deleteModal]="deleteModal"></deletemodal>
<!--create User-->
<div class="main ">
    <!-- <section class="container-fluid no-padding">
        <breadcrumb></breadcrumb>
    </section> -->
    <div class="admin-content">
        <div class="col-xs-12 col-sm-12 col-md-12 card">
            <div class="col-xs-12 " id="msgbox">
                <div *ngIf="showSuccess" class="alert alert-success alert-white rounded show">
                    <button type="button" class="close close-btn" tabindex="0" (keyup.enter)="createSuccessClose()" (click)="createSuccessClose()">×</button>
                    <div class="icon">
                        <i class="fa fa-check"></i>
                    </div>
                    <strong>Success!</strong>
                    <span class="">{{message}}</span>
                </div>
                <div *ngIf="showFailure" class="alert alert-danger alert-white rounded show">
                    <button type="button" class="close close-btn" tabindex="0" (keyup.enter)="createSuccessClose()" (click)="createSuccessClose()">×</button>
                    <div class="icon">
                        <i class="fa fa-times"></i>
                    </div>
                    <span class="alert-msg">{{message}}</span>
                </div>
            </div>
            <div *ngIf="isAssignUserSection">
                <form [formGroup]="userAssignForm" class="col-md-12 marginbot-10 color-validation no-padding " novalidate (ngSubmit)="assignUserSubmit(userAssignForm.value, userAssignForm.valid)">
                    <div class="page-heading">
                        <span class="page-title">{{'store-user.Assign User' |translate}}</span>
                        <a class="backlink backuser-btn show">
                            <i class="fa fa-arrow-circle-left pad-r-8"></i>
                            <span (click)="backToDepartmentUsers()" tabindex="0" (keyup.enter)="backToDepartmentUsers()" class="back-title">{{'store-user.Back to Users' |translate}}</span>
                        </a>
                        <div class="pull-right">
                            <div class="btn-group btn-save-new show">
                                <button class="btn  btn-add " tabindex="0"type="submit" [disabled]="!userAssignForm.valid">
                                    <i class="fa fa-check pad-r-8"></i> {{'store-user.Save' |translate}}</button>
                            </div>
                            <button type="button" class="btn cancel " tabindex="0" (keyup.enter)="clearFormData(4)" (click)="clearFormData(4)">
                                <i class="fa fa-close pad-r-8"></i> {{'store-user.Clear' |translate}}
                            </button>
                        </div>
                    </div>
                    <div class="">
                        <!--2 column gird  -->
                        <div class="col-sm-8 col-xs-12 no-padding">
                              <div class="form-group col-xs-12  col-sm-12 col-md-12">                                
                                     <label for="userselect">{{'store-user.Department Name' |translate}}                                   
                                     </label>                      
                                       : <span class="font-weight-700 font-14" >{{ departmentName}} </span>                                
                               </div>
                            <div class="form-group col-xs-12 col-sm-6">
                                <label for="userselect">{{'store-user.Select User' |translate}}
                                    <span title="{{'store-user.Select User' |translate}}" class="ico-help fa fa-question-circle"></span>
                                </label>
                                <ng-selectize tabindex="0" formControlName="unassignedUserId"  [config]="usersDropdownConfig"  [options]="usersDropdownOptions"  placeholder="{{'store.Click to select...' | translate}}">
                                </ng-selectize>
                            </div>
                            <div class="form-group col-xs-12 multi-select  no-margin">
                                <label for="mulitpletags">{{'store-user.Select Roles' |translate}}
                                    <span title="{{'store-user.Select Roles' |translate}}" class="ico-help fa fa-question-circle"></span>
                                </label>
                                <ng-selectize tabindex="0" formControlName="roleIds"  [config]="rolesDropdownConfig"  [options]="rolesDropdownOptions"  placeholder="{{'store.Click to select...' | translate}}">
                                </ng-selectize>
                            </div>
                        </div>
                        <!--/2 column gird  -->
                        <!--1 column gird will be hide in mobile device  -->
                        <div class="col-sm-4 hidden-xs"></div>
                        <!--/1 column gird   -->
                    </div>
                </form>
            </div>

            <div *ngIf="!isAssignUserSection">
                <form [formGroup]="userUpdateForm" class=" color-validation " novalidate (ngSubmit)="onSubmit()">
                    <div class="page-heading">
                        <span class="page-title">{{userName|translate}} </span>
                        <a class="backlink backuser-btn show">
                            <i class="fa fa-arrow-circle-left pad-r-8"></i>
                            <span (click)="backToDepartmentUsers()" tabindex="0" (keyup.enter)="backToDepartmentUsers()" class="back-title">{{'Back to Users' |translate}}</span>
                        </a>
                        <div class="pull-right">
                            <div class="btn-group btn-save-new show">
                                <button class="btn btn-default btn-save show" tabindex="0" type="submit" [disabled]="!userUpdateForm.valid">
                                    <i class="fa fa-check pad-r-8"></i> {{'Save' |translate}}</button>
                            </div>
                            <button type="button" tabindex="0" (keyup.enter)="clearFormData(4)" class="btn cancel btn-cancel show" (click)="clearFormData(4)">
                                <i class="fa fa-close pad-r-8"></i> {{'Clear' |translate}}
                            </button>
                        </div>
                    </div>
                    <div class="">
                        <!--2 column gird  -->
                        <div class="col-sm-8 col-xs-12 no-padding">
                              <div class="form-group col-xs-12  col-sm-12 col-md-12">                                
                                     <label for="userselect">{{'store-user.Department Name' |translate}}                                   
                                     </label>                      
                                       : <span class="font-weight-700 font-14" >{{ departmentName}} </span>                                
                               </div>
                            <div class="form-group col-xs-12 multi-select  no-margin">
                                <label for="mulitpletags">{{'Selected Roles' |translate}}
                                    <span title="{{'Selected Roles' |translate}}" class="ico-help fa fa-question-circle"></span>
                                </label>
                                <ng-selectize tabindex="0" formControlName="roleUpdateIds"  [config]="rolesDropdownConfig" ngDefaultControl [options]="rolesDropdownOptions"
                                    (ngModelChange)="onValueChangeForUpdateUser($event)"  placeholder="{{'Click to select...' | translate}}">
                                </ng-selectize>
                            </div>
                        </div>
                        <div class="col-sm-4 hidden-xs"></div>
                    </div>
                </form>
                <div class="col-xs-12 col-sm-12 col-md-12 ">
                    <div class="form-heading">
                        <span class="form-title">{{'Permissions' |translate}}</span>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-body" style="margin-top:10px;margin-bottom:10px;">
                            <div class="table-responsive permission-grid" [style.height.px]="permissionsHeight">
                                <table class="table table-hover" id="tblPermissions">
                                    <thead>
                                        <tr *ngIf="departmentLevelPermissionGroupList?.length > 0">
                                            <th></th>
                                            <th class="text-center" *ngFor="let header of permissionHeaders">{{header}}</th>
                                        </tr>
                                        <tr *ngIf="departmentLevelPermissionGroupList?.length === 0">
                                            <th></th>
                                            <th class="text-center">{{'No Permissions available' |translate}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let permissionGroup of departmentLevelPermissionGroupList">
                                            <td class="tablerow">
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox" tabindex="0" [id]="'group-'+permissionGroup.permissionGroupId" value="permissionGroup.permissionGroupId" (change)="groupCheckBox(permissionGroup,$event)"
                                                            [checked]="permissionGroup.selected">
                                                    </label>
                                                </div>
                                                {{permissionGroup.permissionGroupName}}
                                            </td>
                                            <td class="text-center tablerow" *ngFor="let header of permissionHeaders">
                                                <label *ngFor="let permission of permissionGroup.permissionModels">
                                                    <span *ngIf="permission.permissionName==header">
                                                        <input tabindex="0" type="checkbox" attr.id="permission-{{permissionGroup.permissionGroupId+'-'+permission.permissionId}}" value="permission.permissionId"
                                                            (change)="updateCheckedOptions(permission,permissionGroup, $event)"
                                                            [checked]="permission.selected">
                                                    </span>
                                                </label>
                                                <label *ngIf="isPermissionAvailable(permissionGroup.permissionModels,header)" class="font-10"> {{'user.N/A'|translate}} </label>
                                            </td>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/department/department-user-assign-or-retract.component.html